<ng-template
  *ngFor="let portal of templatePortals"
  [cdkPortalOutlet]="portal"
></ng-template>
